import React from 'react'
import { Grid } from '@mui/material'
import NumberField from 'components/forms/NumberField'
import i18n from 'simple-react-i18n'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import Checkbox from 'components/forms/Checkbox'
import PropTypes from 'prop-types'
import { PAR_CONSTANTS } from 'agriAdministration/constants/AgriConstants'

const PARImportParameters = ({ params, setParams }) => {
    return (
        <Grid container size={12} padding={1} sx={{ height: '100%' }}>
            <Grid container spacing={1} >
                <Grid container size={12} spacing={2} alignItems={'center'}>
                    <Grid>
                        <NumberField
                            obligatory
                            title={i18n.askYear}
                            value={params.askYear}
                            onChange={(value) => setParams({ ...params, askYear: value })}
                            sx={{ width: 'auto' }}
                        />
                    </Grid>
                    <Grid />
                </Grid>
                <Grid container size={12} alignItems={'center'} spacing={2}>
                    <Checkbox
                        label={i18n.attributionVolume}
                        checked={params.hasVolumeAttribution}
                        onChange={(isChecked) => {
                            if (isChecked) {
                                setParams({
                                    ...params,
                                    hasVolumeAttribution: isChecked,
                                    columnsData: [
                                        ...params.columnsData,
                                        {
                                            columnNumber: undefined,
                                            lexic: PAR_CONSTANTS.volumeAttribueColumn.value,
                                        }, {
                                            columnNumber: undefined,
                                            lexic: PAR_CONSTANTS.volumeAttribueEtiageColumn.value,
                                        },
                                    ],
                                })
                            } else {
                                setParams({
                                    ...params,
                                    hasVolumeAttribution: isChecked,
                                    attributionDate: undefined,
                                    hasAttributionComments: false,
                                    columnsData: params.columnsData.filter((col) => col.lexic !== PAR_CONSTANTS.volumeAttribueColumn.value && col.lexic !== PAR_CONSTANTS.volumeAttribueEtiageColumn.value && col.lexic !== PAR_CONSTANTS.commentaireAttributionColumn.value),
                                })
                            }
                        }}
                    />
                    <SimpleDatePicker
                        obligatory
                        value={params.attributionDate}
                        label={i18n.attributionDate}
                        onChange={(value) => setParams({ ...params, attributionDate: value })}
                        disabled={!params.hasVolumeAttribution}
                    />
                    <Checkbox
                        label={i18n.attributionComments}
                        checked={params.hasAttributionComments}
                        onChange={(isChecked) => {
                            if (isChecked) {
                                setParams({
                                    ...params,
                                    hasAttributionComments: isChecked,
                                    columnsData:
                                    [...params.columnsData, {
                                        columnNumber: undefined,
                                        lexic: PAR_CONSTANTS.commentaireAttributionColumn.value,
                                    }],
                                })
                            } else {
                                setParams({
                                    ...params,
                                    hasAttributionComments: isChecked,
                                    columnsData: params.columnsData.filter((col) => col.lexic !== PAR_CONSTANTS.commentaireAttributionColumn.value),
                                })
                            }
                        }}
                        disabled={!params.hasVolumeAttribution}
                    />
                </Grid>
                <Grid container size={12} alignItems={'center'} spacing={2}>
                    <Checkbox
                        label={i18n.authorizedVolume}
                        checked={params.hasAuthorisedVolume}
                        onChange={(isChecked) => {
                            if (isChecked) {
                                setParams({
                                    ...params,
                                    hasAuthorisedVolume: isChecked,
                                    columnsData: [
                                        ...params.columnsData,
                                        {
                                            columnNumber: undefined,
                                            lexic: PAR_CONSTANTS.volumeAutoriseColumn.value,
                                        }, {
                                            columnNumber: undefined,
                                            lexic: PAR_CONSTANTS.volumeAutoriseEtiageColumn.value,
                                        },
                                    ],
                                })
                            } else {
                                setParams({
                                    ...params,
                                    hasAuthorisedVolume: isChecked,
                                    authorisationDate: undefined,
                                    hasAutorisationComments: false,
                                    columnsData: params.columnsData.filter((col) => col.lexic !== PAR_CONSTANTS.volumeAutoriseColumn.value && col.lexic !== PAR_CONSTANTS.volumeAutoriseEtiageColumn.value && col.lexic !== PAR_CONSTANTS.commentaireAutorisationColumn.value),
                                })
                            }
                        }}
                    />
                    <SimpleDatePicker
                        obligatory
                        value={params.authorisationDate}
                        label={i18n.authorisationDate}
                        onChange={(value) => setParams({ ...params, authorisationDate: value })}
                        disabled={!params.hasAuthorisedVolume}
                    />
                    <Checkbox
                        label={i18n.authorisationComments}
                        checked={params.hasAutorisationComments}
                        onChange={(isChecked) => {
                            if (isChecked) {
                                setParams({
                                    ...params,
                                    hasAutorisationComments: isChecked,
                                    columnsData:
                                    [...params.columnsData, {
                                        columnNumber: undefined,
                                        lexic: PAR_CONSTANTS.commentaireAutorisationColumn.value,
                                    }],
                                })
                            } else {
                                setParams({
                                    ...params,
                                    hasAutorisationComments: isChecked,
                                    columnsData: params.columnsData.filter((col) => col.lexic !== PAR_CONSTANTS.commentaireAutorisationColumn.value),
                                })
                            }
                        }}
                        disabled={!params.hasAuthorisedVolume}
                    />
                </Grid>
                <Grid container size={12} alignItems={'center'} spacing={2}>
                    <Checkbox
                        label={i18n.requestedVolume}
                        checked={params.hasRequestedVolume}
                        onChange={(isChecked) => {
                            if (isChecked) {
                                setParams({
                                    ...params,
                                    hasRequestedVolume: isChecked,
                                    columnsData: [
                                        ...params.columnsData,
                                        {
                                            columnNumber: undefined,
                                            lexic: PAR_CONSTANTS.volumeDemandeColumn.value,
                                        },
                                    ],
                                })
                            } else {
                                setParams({
                                    ...params,
                                    hasRequestedVolume: isChecked,
                                    hasRequestedLowWaterVolume: false,
                                    columnsData: params.columnsData.filter((col) => col.lexic !== PAR_CONSTANTS.volumeDemandeColumn.value && col.lexic !== PAR_CONSTANTS.volumeDemandeEtiageColumn.value),
                                })
                            }
                        }}
                    />
                    <Checkbox
                        label={i18n.askedLowWaterVolume}
                        checked={params.hasRequestedLowWaterVolume}
                        disabled={!params.hasRequestedVolume}
                        onChange={(isChecked) => {
                            if (isChecked) {
                                setParams({
                                    ...params,
                                    hasRequestedLowWaterVolume: isChecked,
                                    columnsData: [...params.columnsData, {
                                        columnNumber: undefined,
                                        lexic: PAR_CONSTANTS.volumeDemandeEtiageColumn.value,
                                    }],
                                })
                            } else {
                                setParams({
                                    ...params,
                                    hasRequestedLowWaterVolume: isChecked,
                                    columnsData: params.columnsData.filter((col) => col.lexic !== PAR_CONSTANTS.volumeDemandeEtiageColumn.value),
                                })
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

PARImportParameters.propTypes = {
    params: PropTypes.shape({
        columnsData: PropTypes.arrayOf(PropTypes.shape({
            columnNumber: PropTypes.number,
            lexic: PropTypes.number,
        })).isRequired,
        askYear: PropTypes.number.isRequired,
        hasVolumeAttribution: PropTypes.bool.isRequired,
        hasAttributionComments: PropTypes.bool.isRequired,
        attributionDate: PropTypes.string.isRequired,
        hasAuthorisedVolume: PropTypes.bool.isRequired,
        authorisationDate: PropTypes.string.isRequired,
        hasAutorisationComments: PropTypes.bool.isRequired,
        hasRequestedVolume: PropTypes.bool.isRequired,
        hasRequestedLowWaterVolume: PropTypes.bool.isRequired,
    }).isRequired,
    setParams: PropTypes.func.isRequired,
}

export default PARImportParameters